/**
 * TariffEditSheet — мобильный bottom-sheet правки тарифа: каркас (грип,
 * заголовок, закрытие) + тело Соло/Клиника. Тела монтируются по режиму
 * (черновик сбрасывается при открытии). «Сохранить» отдаёт запрос наружу.
 */

import {X} from 'lucide-react';

import type {ClinicTariff, SaveClinicInput, SoloTariff} from '@services/tariffs';
import {SheetGrabber} from '@components/SheetGrabber';
import {Sheet, SheetContent} from '@components/ui/Sheet';

import {ClinicEditBody} from './ClinicEditBody';
import {SoloEditBody} from './SoloEditBody';

type TariffEditSheetProps = {
  editing: 'solo' | 'clinic' | null;
  solo: SoloTariff;
  clinic: ClinicTariff;
  onClose: () => void;
  onAskSaveSolo: (price: number) => void;
  onAskSaveClinic: (input: SaveClinicInput) => void;
};

export const TariffEditSheet = ({
  editing,
  solo,
  clinic,
  onClose,
  onAskSaveSolo,
  onAskSaveClinic,
}: TariffEditSheetProps) => (
  <Sheet open={editing !== null} onOpenChange={(o) => !o && onClose()}>
    <SheetContent
      side="bottom"
      showClose={false}
      className="top-[56px] flex flex-col gap-0 rounded-t-[22px] bg-[#F5F6F8] p-0"
    >
      <div className="rounded-t-[22px] border-b border-skr-line bg-card px-[18px] pb-3 pt-2">
        <SheetGrabber className="mb-3" />
        <div className="flex items-center justify-between">
          <div className="text-[17px] font-bold">
            {editing === 'solo' ? 'Тариф Соло' : 'Пакеты клиники'}
          </div>
          <button
            onClick={onClose}
            aria-label="Закрыть"
            className="grid size-8 place-items-center rounded-[9px] bg-secondary text-muted-foreground"
          >
            <X className="size-4" strokeWidth={2} />
          </button>
        </div>
      </div>

      {editing === 'solo' ? (
        <SoloEditBody solo={solo} onClose={onClose} onAskSave={onAskSaveSolo} />
      ) : (
        <ClinicEditBody clinic={clinic} onClose={onClose} onAskSave={onAskSaveClinic} />
      )}
    </SheetContent>
  </Sheet>
);
